import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    styleUrls: ['./terms-and-conditions.component.css'],
    standalone: false
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {
  private router = inject(Router);
  private readonly destroy$ = new Subject<void>();


  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
          return;
      }
      window.scrollTo(0, 0)
  });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
